import services from '../../services'

export interface LinkPowerBi {
  caminho: string
  workspaceId: string
  id: string
  tipo: 'powerbi' | 'html'
  nome: string
  /** Relatório: o dataset que ele usa (groups/{ws}/datasets/{id}) e o nome. */
  datasetCaminho?: string | null
  datasetNome?: string | null
}

/** Confere o link no Power BI. Devolve o que achou, ou a frase do problema. */
export async function conferirLink(link: string): Promise<LinkPowerBi | string> {
  const r = await services.api.novoPortalConferirLink(link.trim())
  if (r.fail) return r.error || 'Não foi possível conferir o link agora.'
  return r.data
}

/** O caminho do dataset gravado no dashboard, ou vazio. */
export function caminhoDoDataset(d: { datasetId?: string | null; datasetWorkspaceId?: string | null; workspaceId?: string | null }): string {
  const ws = d.datasetWorkspaceId || d.workspaceId
  return d.datasetId && ws ? `groups/${ws}/datasets/${d.datasetId}` : ''
}

/** "Atualizar a tela sozinho": o cadastro guarda segundos (mais de 10). */
export const OPCOES_ATUALIZACAO = [
  { valor: '', rotulo: 'Não' },
  { valor: '300', rotulo: 'A cada 5 min' },
  { valor: '900', rotulo: 'A cada 15 min' },
  { valor: '1800', rotulo: 'A cada 30 min' },
  { valor: '3600', rotulo: 'A cada 1 h' }
]

export function rotuloAtualizacao(segundos?: number | null): string {
  if (!segundos) return 'Não'
  const o = OPCOES_ATUALIZACAO.find(x => x.valor === String(segundos))
  if (o) return o.rotulo
  return segundos % 60 === 0 ? `A cada ${segundos / 60} min` : `A cada ${segundos} s`
}

export function plural(n: number, um: string, varios: string) {
  return `${n} ${n === 1 ? um : varios}`
}

// Como no portal antigo: a lista de pessoas e de equipes fica com quem cria dashboard (para
// escolher a quem dar acesso), mas a ficha da pessoa (telefone, regras, acessos, oneflow) e o
// detalhe da equipe (membros e acessos) pedem administrador do BI ou leitura de usuários/equipes.
// O servidor confere o mesmo; aqui é só para não oferecer um clique que vai dar "sem permissão".
export const podeVerFicha = (roles: string[] | null | undefined) =>
  !!roles && (roles.includes('bi_dashboards_read_any') || roles.includes('common_users_read_any'))
export const podeVerEquipe = (roles: string[] | null | undefined) =>
  !!roles && (roles.includes('bi_dashboards_read_any') || roles.includes('bi_teams_read_any'))
export const SEM_FICHA = 'A ficha completa (telefone, regras, acessos e oneflow) é só para administradores do BI ou quem lê usuários.'
export const SEM_EQUIPE = 'Os membros e acessos da equipe são só para administradores do BI ou quem lê equipes.'
